import { Modal } from 'bootstrap';

export function componentModalInterstitial(): void {
    const modal = document.getElementById('modalInterstitial'); // Bootstrap modal DOM element
    if (!modal) { return; }

    // Create Bootstrap Modal instance
    const modalInstance = new Modal(modal);
    
    const modalContentInternal = modal.querySelector('[data-content-internal]');
    const modalContentExternal = modal.querySelector('[data-content-external]');
    const modalContentOperation = modalContentExternal
        ? Array.from(modalContentExternal.querySelectorAll('[data-interstitial-operation]'))
        : [];
    const modalLinks = Array.from(modal.querySelectorAll('[data-modal-link]'));
    const modalButtonClose = modal.querySelector('[data-modal-close]') as HTMLElement;

    // Find all triggers for this modal and add event listeners
    const modalTriggers = document.querySelectorAll('[data-interstitial');

    modalTriggers.forEach((trigger) => {
        trigger.addEventListener('click', (event) => {
            event.preventDefault(); // Prevent default link behavior
            
            // Get the URL and type from the trigger
            let url: string = '';
            let interstitialType: string = '';
            let interstitialOperation: string = '';
            if (trigger.nodeName === 'A') {
                url = (trigger as HTMLAnchorElement).href;
                interstitialType = (trigger as HTMLAnchorElement).dataset.interstitial || '';
                interstitialOperation = (trigger as HTMLAnchorElement).dataset.interstitialOperation || '';
            } else if (trigger.nodeName === 'BUTTON') {
                url = (trigger as HTMLButtonElement).dataset.url || '';
                interstitialType = (trigger as HTMLButtonElement).dataset.interstitial || '';
                interstitialOperation = (trigger as HTMLAnchorElement).dataset.interstitialOperation || '';
            }
            
            // Update modal links
            if (url && url !== '#') {
                modalLinks.forEach((link) => {
                    link.setAttribute('href', url);
                });
            }

            // Update modal content
            if (interstitialType && modalContentInternal && modalContentExternal) {
                (modalContentInternal as HTMLElement).hidden = true;
                (modalContentExternal as HTMLElement).hidden = true;
                // Hide all external dynamic content
                modalContentOperation.forEach(block => {
                    (block as HTMLElement).hidden = true;
                });

                if (interstitialType === 'internal') {
                    (modalContentInternal as HTMLElement).hidden = false;
                } else if (interstitialType === 'external') {
                    // Update dynamic content
                    if (interstitialOperation === 'payment') {
                        modalContentOperation
                            .filter((block) => (block as HTMLElement).dataset.interstitialOperation === 'payment')
                            .forEach((block) => {
                                (block as HTMLElement).hidden = false;
                            });
                    }
                    else if (interstitialOperation === 'treatment') {
                        modalContentOperation
                            .filter((block) => (block as HTMLElement).dataset.interstitialOperation === 'treatment')
                            .forEach((block) => {
                                (block as HTMLElement).hidden = false;
                            });
                    }

                    // Show external content
                    (modalContentExternal as HTMLElement).hidden = false;
                }
            }
            
            // Show the modal
            modalInstance.show();
        });
    });

    modal.addEventListener('show.bs.modal', function (event) {
        let trigger = (event as any).relatedTarget; // Element that triggered the modal
        if (!trigger) { return; }
        let url: string = '';

        // Trigger can be a link or a button.
        // If a link, grab the href value.
        if (trigger.nodeName === 'A') {
            url = trigger.href;
        }
        // If a button, grab the data-url value.
        if (trigger.nodeName === 'BUTTON') {
            url = trigger.dataset.url;
        }
        
        // Replace the outbound links in the modal.
        if (url && url !== '#') {
            modalLinks.forEach(function (link) {
                link.setAttribute('href', url);
            });
        }
    });

    // Close the modal when outbound link is clicked inside WOL.
    modalLinks.forEach(function (link) {
        if (!modalButtonClose) { return; }
        link.addEventListener('click', function () {
            modalInstance.hide();
        });
    });

    // Close modal when close button is clicked
    if (modalButtonClose) {
        modalButtonClose.addEventListener('click', function () {
            modalInstance.hide();
        });
    }
}